import cloneDeep from 'lodash/cloneDeep'
import { RESET_GAME_STATE, ADD_PAGE_STATE, SET_BATTLE_RESULT_STATE } from '../../actions/game/gameState.actions'
import { GOTO_HOME } from '../../actions/routing/route.actions'

const initialState = {
    page: [GOTO_HOME],
    battleResult: undefined,
}

const gameStateReducer = (state = initialState, action) => {
    const { payload } = action

    switch (action.type) {
        case RESET_GAME_STATE: {
            return initialState
        }

        case ADD_PAGE_STATE: {
            const { page } = payload
            const { page: oldPage } = state

            const oldPageIndex = oldPage.findIndex(i => i === page)

            if (oldPageIndex === -1) {
                const newPage = [...oldPage, page]
                return { ...cloneDeep(state), page: newPage }
            }
            const slicedPage = [...oldPage.slice(0, oldPageIndex + 1)]
            return { ...cloneDeep(state), page: slicedPage }
        }

        case SET_BATTLE_RESULT_STATE: {
            const { battleResult } = payload
            return { ...cloneDeep(state), battleResult }
        }

        default: {
            return state
        }
    }
}

export default gameStateReducer
